/**
 * Collection authorize and withdraw failures (TMMRSL-0081, TMMRSL-0082). The server's message is
 * never shown. `503 PAY_API_UNAVAILABLE` on a withdraw is not an inline error: the dialog closes
 * and a warning toast uses `resellerBilling.collection.error.withdrawUnconfirmed`.
 */
import type { TFunction } from 'i18next';
import { backendCode } from '@/api/errors';

const AUTHORIZE_ERRORS: Readonly<Record<string, string>> = {
  PAYEE_NOT_FOUND: 'resellerBilling.collection.error.payeeNotFound',
  COLLECTION_CARD_REQUIRED: 'resellerBilling.collection.error.cardRequired',
  AGREEMENT_REQUIRED: 'resellerBilling.collection.error.agreementRequired',
  COLLECTION_CONSENT_REVOKED: 'resellerBilling.collection.error.consentRevoked',
};

function message(err: unknown, t: TFunction, codes: Readonly<Record<string, string>>): string | null {
  const code = backendCode(err);
  if (code === undefined || !Object.hasOwn(codes, code)) return null;
  return t(codes[code] as string);
}

/** `POST` collection authorization. */
export function collectionAuthorizeError(err: unknown, t: TFunction): string | null {
  return message(err, t, AUTHORIZE_ERRORS);
}
